import { render, staticRenderFns } from "./IFilters.vue?vue&type=template&id=a92b26ba&scoped=true&"
import script from "./IFilters.vue?vue&type=script&lang=js&"
export * from "./IFilters.vue?vue&type=script&lang=js&"
import style0 from "./IFilters.vue?vue&type=style&index=0&id=a92b26ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92b26ba",
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator});
